

import http from '@/services/http'

export const SET_LIST_CONTAS_RECEBER = 'setListContasReceber'
export const SET_CONTA_RECEBER = 'setContaReceber'
export const SET_CONTA_RECEBER_NEW = 'setContasReceberNew'
export const SET_EMPRESAS_CONTAS_RECEBER = 'setEmpresasContasReceber'

export const SET_MESSAGE_ALERT = 'setMessage'
const actions = {

    async listar_empresas_contas_receber(context, params) {
        await http.get('contas-receber/empresas',{params:params})
            .then(response => context.commit(SET_EMPRESAS_CONTAS_RECEBER, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async listar_contas_receber(context, params) {
        await http.get('contas-receber',{params:params})
            .then(response => context.commit(SET_LIST_CONTAS_RECEBER, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async listar_conta_receber(context, params) {
        await http.get('contas-receber/' + params)
            .then(response => context.commit(SET_CONTA_RECEBER, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async create_contas_receber(context, value) {
        let message = await http.post('contas-receber', value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        context.commit(SET_CONTA_RECEBER_NEW, message.message.conteudo)
    },
    async update_contas_receber(context, value) {
        let data = await http.put('contas-receber/' + value.id, value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, data)
    },
    set_atividade(context, value) {
        context.commit(SET_CONTA_RECEBER, value)
    }
};
const mutations = {

    [SET_MESSAGE_ALERT](state, value) {
        console.log(value)
        let customMessage;
        if (typeof value.message === "object") {

            customMessage = value.message.msg;
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },
    [SET_LIST_CONTAS_RECEBER](state, value) {
        state.lista_contas_receber = value
    },
    [SET_CONTA_RECEBER](state, value) {
        state.conta_receber = value
    },
    [SET_CONTA_RECEBER_NEW](state, value) {
        state.lista_contas_receber.push(value)
    },

    [SET_EMPRESAS_CONTAS_RECEBER](state, value) {
        state.lista_empresas_contas_receber = value
    }
};
const getters = {

}

const state = {
    mensagem_alert: [],
    lista_contas_receber: {
        pagination: {
            current_page: 1,
            total_pages: 1,
            per_page: 10,
            total: 1,
        },
        data: [],
    },
    lista_empresas_contas_receber: {
        pagination: {
            current_page: 1,
            total_pages: 1,
            per_page: 10,
            total: 1,
        },
        data: [],
    },
    conta_receber: {},
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};


